module.exports = __webpack_public_path__ + "static/media/flac-icon.0e27bbe0.svg";